import styled from 'styled-components';
import { color } from 'styles/colors';

export const container = styled.div`
  width: 100%;
  height: 100%;
  padding: 32px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const title = styled.h1`
  color: #469bff;
  font-family: Poppins;
  font-size: 30px;
  padding-bottom: 10px;
`;

export const box = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  box-sizing: content-box;
  grid-template-rows: min-content 1fr min-content;
  flex-direction: column;
  gap: 0.8rem;
  box-sizing: content-box;
  background-color: ${color.interface.white};
  border-radius: 5px;
  overflow: auto;
  padding: 10px;
`;

export const boxPagination = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
